import { ExternalLink } from "lucide-react";
import type { Node, NodeProps } from "@xyflow/react";

import { formatStatusLabel } from "@/lib/format";

import { FlowNodeCard, FlowNodeRow, LeftTargetHandle } from "./shared";
import type { DocumentNodeData } from "./types";

type DocumentFlowNode = Node<DocumentNodeData, "document">;

function DocumentLink({ url }: { url?: string | null }) {
  if (!url) return <span>-</span>;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 text-primary hover:underline"
    >
      <span>Open</span>
      <ExternalLink className="size-3" />
    </a>
  );
}

export function DocumentNode({ data }: NodeProps<DocumentFlowNode>) {
  return (
    <>
      <LeftTargetHandle />
      <FlowNodeCard title="Document">
        <FlowNodeRow label="Type" value={formatStatusLabel(data.documentType, "Unknown")} />
        <FlowNodeRow label="Link" value={<DocumentLink url={data.url} />} />
      </FlowNodeCard>
    </>
  );
}
